var _circle, _circle2, _circle3, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBubblesArrowArc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 80,
    viewBox: "0 0 56 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43.0756,
    cy: 12.1237,
    r: 12,
    transform: "rotate(0.0638494 43.0756 12.1237)",
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.0478,
    cy: 36.0301,
    r: 9,
    transform: "rotate(0.0638494 25.0478 36.0301)",
    fill: "#D9D9D9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5072,
    cy: 56.5073,
    r: 6.5,
    transform: "rotate(0.0638494 12.5072 56.5073)",
    fill: "#D9D9D9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.51036,
    cy: 74.506,
    r: 4.5,
    transform: "rotate(0.0638494 4.51036 74.506)",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubblesArrowArc);
export default __webpack_public_path__ + "static/media/bubbles-arrow-arc.cc56f0ad8fc7f8818a624a94c30a77c7.svg";
export { ForwardRef as ReactComponent };